interface SectionHeaderProps {
  title: string;
  description: string;
}

export default function SectionHeader({ title, description }: SectionHeaderProps) {
  return (
    <div>
      <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">{title}</h1>
      <p className="text-sm md:text-base text-foreground-600 mt-1 max-w-2xl">{description}</p>
    </div>
  );
}